import { createNS } from "./util";

const NAMESPACE = "ERRORS/DOCUMENTS";
const ns = createNS(NAMESPACE);

export const DOCUMENT_PROCESSING_ERROR = ns("UNKNOWN");
